export default __webpack_public_path__ + "static/media/lucid_header.d8088812.webp";